import React from 'react';

const steps = [
  {
    number: 1,
    icon: '/images/casa.png',
    alt: 'Espacio',
    text: '¿Tienes un espacio que requiere limpieza o mantenimiento?',
  },
  {
    number: 2,
    icon: '/images/imagen5.png',
    alt: 'Limpieza',
    text: 'Limpieza profunda de casa, departamento, oficina y negocio. Terminación de obra.',
  },
  {
    number: 3,
    icon: '/images/herramientas.png',
    alt: 'Mantenimiento',
    text: 'Mantenimiento en electricidad, plomería, carpintería, pintura y albañilería.',
  },
  {
    number: 4,
    icon: '/images/contact.png',
    alt: 'Contacto',
    text: 'Contáctanos y nosotros lo hacemos por ti.',
  },
];

const ComoFunciona = () => {
  return (
    <section id="section4" className="bg-white py-16">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-2">
          ¿Cómo Funciona?
        </h2>
        <div className="mx-auto mb-12 w-12 h-1 bg-orange-500 rounded"></div>

        <div className="flex flex-col md:flex-row items-start justify-between gap-8">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div className="flex flex-col items-center text-center flex-1 min-w-0">
                <div className="relative mb-4">
                  <span className="absolute -top-2 -right-2 w-6 h-6 bg-orange-500 text-white text-xs font-bold rounded-full flex items-center justify-center z-10">
                    {step.number}
                  </span>
                  <div className="w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center">
                    <img
                      src={step.icon}
                      alt={step.alt}
                      className="w-10 h-10"
                      loading="lazy"
                    />
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed max-w-[160px]">{step.text}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:flex items-center self-center flex-shrink-0 mt-[-2rem]">
                  <div className="w-8 border-t-2 border-dashed border-orange-200"></div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComoFunciona;
